import { auditLogGridContract, useDataGrid } from '@/modules/data-grid'

export type AuditSubjectType = 'User' | 'Agent' | 'Policy'

export function useSubjectAuditLogGrid(
  entityId: string,
  subjectType: AuditSubjectType,
  subjectId: string,
  urlState: boolean,
) {
  return useDataGrid({
    contract: auditLogGridContract,
    queryKey: ['audit', 'subject-log', entityId, subjectType, subjectId],
    endpoint: `/api/v1/entities/${encodeURIComponent(entityId)}/audit-log?${new URLSearchParams({ subjectType, subjectId })}`,
    urlState,
    columnStorageKey: 'audit-log:subject',
    hiddenColumns: ['subjectType'],
  })
}
